/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { getPostAPIMethod } from '@neum/frontend-shared/utils/api';

export const ReferrerTracking = getPostAPIMethod('/v1/track_referrer', { baseUrl: import.meta.env.REACT_APP_ENDPOINT });